import axios from 'axios'
import LocalStorage from '@/local-storage/LocalStorageHelper'
import * as LocalStorageKeys from '@/local-storage/LocalStorageKeys'

const getZonesFromLocalStorage = () => {
  let zones = LocalStorage.get(LocalStorageKeys.CACHE_ZONE_CODES)
  return zones !== null ? zones : []
}

const getters = {
  zoneCodes: state => state.zoneCodes,
}

const state = {
  zoneCodes: getZonesFromLocalStorage(),
}

const mutations = {
  'ADD_TO_ZONE_CODES': function (state, zoneCodes) {
    state.zoneCodes = state.zoneCodes.concat(zoneCodes)
    LocalStorage.set(LocalStorageKeys.CACHE_ZONE_CODES, state.zoneCodes)
  },
}

const actions = {
  'GET_ZONE_CODES': ({ state, commit }, params) => {
    if (params.hasOwnProperty('zones') && params.zones.length > 0) {
      params.level = params.hasOwnProperty('level') ? params.level : 1

      params.zones = params.zones.filter(element => {
        return !state.zoneCodes.some(zoneCode => zoneCode.uid === element)
      })

      if (params.zones.length > 0) {
        params.zones = params.zones.join(',')

        axios.get(`${process.env.VUE_APP_AUTH_URL}/zones`, { params })
          .then(response => commit('ADD_TO_ZONE_CODES', response.data.data))
          .catch(errors => console.log(errors))
      }
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
